import { BRIEF_SCRIPTING_QUERY_KEY } from "@entities/brief/lib/constants";
import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { IDeleteScriptComment } from "@shared/lib/types/briefCampains";
import { BriefConfigService } from "../../services/briefConfigService";

export function useDeleteComment(scriptId: string) {
  const {
    mutate: deleteComment,
    isLoading: isDeleting,
    isSuccess: isDeleted,
    variables,
  } = useMutation({
    mutationFn: (payload: IDeleteScriptComment) =>
      BriefConfigService.deleteScriptComment(payload).catch(async (err) => {
        const responseBody = await err.response?.json?.();
        if (responseBody?.msg) ToastService.error(responseBody.msg);
        throw err;
      }),
    options: { skipInvalidation: true },
    onSuccess: (c) => {
      c.invalidateQueries({ queryKey: BRIEF_SCRIPTING_QUERY_KEY(scriptId) });
    },
  });

  return { deleteComment, isDeleting, isDeleted, variables };
}
